var _regeneratorRuntime = require("/ws/61941e029dd8eb000197c556/095e8b3251cd4da4bfbd4c9ec23a8ade/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _objectSpread = require("/ws/61941e029dd8eb000197c556/095e8b3251cd4da4bfbd4c9ec23a8ade/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread");

var _awaitAsyncGenerator = require("/ws/61941e029dd8eb000197c556/095e8b3251cd4da4bfbd4c9ec23a8ade/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/awaitAsyncGenerator");

var _wrapAsyncGenerator = require("/ws/61941e029dd8eb000197c556/095e8b3251cd4da4bfbd4c9ec23a8ade/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/wrapAsyncGenerator");

var _asyncIterator = require("/ws/61941e029dd8eb000197c556/095e8b3251cd4da4bfbd4c9ec23a8ade/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncIterator");

var _require = require('buffer'),
    Buffer = _require.Buffer;

var BufferList = require('bl/BufferList');

var _require2 = require('iso-constants'),
    S_IFMT = _require2.S_IFMT,
    S_IFBLK = _require2.S_IFBLK,
    S_IFCHR = _require2.S_IFCHR,
    S_IFDIR = _require2.S_IFDIR,
    S_IFIFO = _require2.S_IFIFO,
    S_IFLNK = _require2.S_IFLNK;

var concat = require('it-concat');

var Headers = require('./pack-headers');

var DMODE = parseInt('755', 8);
var FMODE = parseInt('644', 8);
var END_OF_TAR = Buffer.alloc(1024);

function modeToType(mode) {
  switch (mode & S_IFMT) {
    case S_IFBLK:
      return 'block-device';

    case S_IFCHR:
      return 'character-device';

    case S_IFDIR:
      return 'directory';

    case S_IFIFO:
      return 'fifo';

    case S_IFLNK:
      return 'symlink';
  }

  return 'file';
}

function getPadding(size) {
  size &= 511;
  if (size) return new BufferList(END_OF_TAR.slice(0, 512 - size));
}

function encode(header) {
  if (!header.pax) {
    var encoded = Headers.encode(header);
    if (encoded) return encoded;
  }

  return encodePax(header);
}

function encodePax(header) {
  var paxHeader = Headers.encodePax({
    name: header.name,
    linkname: header.linkname,
    pax: header.pax
  });
  var newHeader = {
    name: 'PaxHeader',
    mode: header.mode,
    uid: header.uid,
    gid: header.gid,
    size: paxHeader.length,
    mtime: header.mtime,
    type: 'pax-header',
    linkname: header.linkname && 'PaxHeader',
    uname: header.uname,
    gname: header.gname,
    devmajor: header.devmajor,
    devminor: header.devminor
  };
  return new BufferList([Headers.encode(newHeader), paxHeader, getPadding(paxHeader.length), Headers.encode(_objectSpread({}, newHeader, {
    size: header.size,
    type: header.type
  }))]);
}

module.exports = function () {
  return /*#__PURE__*/function () {
    var _ref = _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(source) {
      var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, _value3, header, body, written, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, _value2, chunk, overflow;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _iteratorNormalCompletion = true;
              _didIteratorError = false;
              _context.prev = 2;
              _iterator = _asyncIterator(source);

            case 4:
              _context.next = 6;
              return _awaitAsyncGenerator(_iterator.next());

            case 6:
              _step = _context.sent;
              _iteratorNormalCompletion = _step.done;
              _context.next = 10;
              return _awaitAsyncGenerator(_step.value);

            case 10:
              _value = _context.sent;

              if (_iteratorNormalCompletion) {
                _context.next = 81;
                break;
              }

              _value3 = _value, header = _value3.header, body = _value3.body;
              if (!header.size || header.type === 'symlink') header.size = 0;
              if (!header.type) header.type = modeToType(header.mode);
              if (!header.mode) header.mode = header.type === 'directory' ? DMODE : FMODE;
              if (!header.uid) header.uid = 0;
              if (!header.gid) header.gid = 0;
              if (!header.mtime) header.mtime = new Date();
              if (typeof body === 'string') body = Buffer.from(body);

              if (!(Buffer.isBuffer(body) || BufferList.isBufferList(body))) {
                _context.next = 25;
                break;
              }

              header.size = body.length;
              _context.next = 24;
              return new BufferList([encode(header), body, getPadding(header.size)]);

            case 24:
              return _context.abrupt("continue", 78);

            case 25:
              if (!(header.type === 'symlink' && !header.linkname)) {
                _context.next = 32;
                break;
              }

              _context.next = 28;
              return _awaitAsyncGenerator(concat(body));

            case 28:
              header.linkname = _context.sent.toString();
              _context.next = 31;
              return encode(header);

            case 31:
              return _context.abrupt("continue", 78);

            case 32:
              _context.next = 34;
              return encode(header);

            case 34:
              if (!(header.type !== 'file' && header.type !== 'contiguous-file')) {
                _context.next = 36;
                break;
              }

              return _context.abrupt("continue", 78);

            case 36:
              written = 0;
              _iteratorNormalCompletion2 = true;
              _didIteratorError2 = false;
              _context.prev = 39;
              _iterator2 = _asyncIterator(body);

            case 41:
              _context.next = 43;
              return _awaitAsyncGenerator(_iterator2.next());

            case 43:
              _step2 = _context.sent;
              _iteratorNormalCompletion2 = _step2.done;
              _context.next = 47;
              return _awaitAsyncGenerator(_step2.value);

            case 47:
              _value2 = _context.sent;

              if (_iteratorNormalCompletion2) {
                _context.next = 56;
                break;
              }

              chunk = _value2;
              written += chunk.length;
              _context.next = 53;
              return BufferList.isBufferList(chunk) ? chunk : new BufferList(chunk);

            case 53:
              _iteratorNormalCompletion2 = true;
              _context.next = 41;
              break;

            case 56:
              _context.next = 62;
              break;

            case 58:
              _context.prev = 58;
              _context.t0 = _context["catch"](39);
              _didIteratorError2 = true;
              _iteratorError2 = _context.t0;

            case 62:
              _context.prev = 62;
              _context.prev = 63;

              if (!(!_iteratorNormalCompletion2 && _iterator2.return != null)) {
                _context.next = 67;
                break;
              }

              _context.next = 67;
              return _awaitAsyncGenerator(_iterator2.return());

            case 67:
              _context.prev = 67;

              if (!_didIteratorError2) {
                _context.next = 70;
                break;
              }

              throw _iteratorError2;

            case 70:
              return _context.finish(67);

            case 71:
              return _context.finish(62);

            case 72:
              if (!(written !== header.size)) {
                _context.next = 74;
                break;
              }

              throw new Error('size mismatch');

            case 74:
              overflow = getPadding(header.size);

              if (!overflow) {
                _context.next = 78;
                break;
              }

              _context.next = 78;
              return overflow;

            case 78:
              _iteratorNormalCompletion = true;
              _context.next = 4;
              break;

            case 81:
              _context.next = 87;
              break;

            case 83:
              _context.prev = 83;
              _context.t1 = _context["catch"](2);
              _didIteratorError = true;
              _iteratorError = _context.t1;

            case 87:
              _context.prev = 87;
              _context.prev = 88;

              if (!(!_iteratorNormalCompletion && _iterator.return != null)) {
                _context.next = 92;
                break;
              }

              _context.next = 92;
              return _awaitAsyncGenerator(_iterator.return());

            case 92:
              _context.prev = 92;

              if (!_didIteratorError) {
                _context.next = 95;
                break;
              }

              throw _iteratorError;

            case 95:
              return _context.finish(92);

            case 96:
              return _context.finish(87);

            case 97:
              _context.next = 99;
              return new BufferList(END_OF_TAR);

            case 99:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[2, 83, 87, 97], [39, 58, 62, 72], [63,, 67, 71], [88,, 92, 96]]);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
};